import { Home } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

interface BackToHomeProps {
  className?: string;
  onClick?: () => void;
  to?: string;
  label?: string;
  showIcon?: boolean;
}

export default function BackToHome({
  className = '',
  onClick,
  to,
  label = 'Back to Home',
  showIcon = true
}: BackToHomeProps) {
  const navigate = useNavigate();
  const { user } = useAuth();

  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();

    if (onClick) {
      onClick();
    } else {
      const destination = to || (user ? '/dashboard' : '/');
      navigate(destination);
    }
  };

  return (
    <button
      onClick={handleClick}
      className={`flex items-center gap-2 text-[#6B7280] hover:text-[#1F2937] font-medium transition focus:outline-none focus:ring-2 focus:ring-[#8CAFA8] focus:ring-offset-2 rounded ${className}`}
      aria-label={label}
    >
      {showIcon && <Home className="w-5 h-5" strokeWidth={1.5} aria-hidden="true" />}
      <span>{label}</span>
    </button>
  );
}
